var map = {
	"./social-500px.svg": 411,
	"./social-dribbble.svg": 412,
	"./social-facebook.svg": 413,
	"./social-github.svg": 414,
	"./social-google.svg": 415,
	"./social-instagram.svg": 416,
	"./social-odnoklassniki.svg": 417,
	"./social-reddit.svg": 418,
	"./social-stackoverflow.svg": 419,
	"./social-steam.svg": 420,
	"./social-twitch.svg": 421,
	"./social-twitter.svg": 422,
	"./social-vkontakte.svg": 423,
	"./social-windows.svg": 424,
	"./social-wordpress.svg": 425,
	"./social-yahoo.svg": 426
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 410;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth ^\.\/social\-.*\.svg$
// module id = 410
// module chunks = 0